import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { getCaptureLocationMap } from "../../api/captures/captureLocation";
import { listCaptures } from "../../api/captures/listCaptures";
import { getEntities } from "../../api/entities";
import { listManagementUnits } from "../../api/managementUnits";

interface FilterOptions {
  entityId?: number;
  managementUnitId?: number;
  militaryMap?: string;
  search?: string;
}

export const useListCaptures = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [filtersState, setFiltersState] = useState<FilterOptions>({});

  const setFilters = (newFilters: FilterOptions) => {
    setPage(0);
    setFiltersState(newFilters);
  };

  const capturesQuery = useQuery({
    queryKey: ["captures", { page, rowsPerPage, ...filtersState }],
    queryFn: () =>
      listCaptures(
        filtersState.entityId,
        filtersState.managementUnitId,
        filtersState.search,
        filtersState.militaryMap,
        rowsPerPage,
        page * rowsPerPage
      ),
    placeholderData: keepPreviousData,
  });

  const mapQuery = useQuery({
    queryKey: ["captures", "map", { filtersState }],
    queryFn: () =>
      getCaptureLocationMap(
        filtersState.entityId,
        filtersState.managementUnitId,
        undefined,
        filtersState.militaryMap,
        filtersState.search
      ),
    enabled: !!(
      filtersState.entityId ||
      filtersState.managementUnitId ||
      filtersState.militaryMap ||
      filtersState.search
    ),
    placeholderData: keepPreviousData,
  });

  const entitiesQuery = useQuery({
    queryKey: ["entities"],
    queryFn: () => getEntities(),
  });

  const managementUnitsQuery = useQuery({
    queryKey: ["managementUnits"],
    queryFn: () => listManagementUnits(),
  });

  return {
    page,
    rowsPerPage,
    filters: filtersState,
    setPage,
    setRowsPerPage,
    setFilters,
    capturesQuery,
    mapQuery,
    entitiesQuery,
    managementUnitsQuery,
  };
};
